import type { IconAsset } from '../Icon.types';

export const facebook: IconAsset = {
  regular: {
    l: {
      code: (
        <path
          clipRule='evenodd'
          d='M14.902 5.89438H16.571V2.98744C16.2831 2.94783 15.2928 2.8587 14.1395 2.8587C11.733 2.8587 10.0845 4.37235 10.0845 7.15435V9.71468H7.42899V12.9644H10.0845V21.1413H13.3404V12.9652H15.8885L16.293 9.71544H13.3396V7.47658C13.3404 6.53731 13.5933 5.89438 14.902 5.89438Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    m: {
      code: (
        <path
          clipRule='evenodd'
          d='M12.4183 4.91199H13.8092V2.48955C13.5692 2.45654 12.744 2.38226 11.7829 2.38226C9.77752 2.38226 8.40378 3.64364 8.40378 5.96197V8.09557H6.19083V10.8037H8.40378V17.6178H11.117V10.8043H13.2404L13.5775 8.09621H11.1163V6.23049C11.117 5.44777 11.3277 4.91199 12.4183 4.91199Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    s: {
      code: (
        <path
          clipRule='evenodd'
          d='M9.93467 3.9296H11.0474V1.99165C10.8554 1.96524 10.1952 1.90582 9.42632 1.90582C7.82202 1.90582 6.72303 2.91492 6.72303 4.76959V6.47647H4.95267V8.64296H6.72303V14.0942H8.89358V8.64347H10.5923L10.862 6.47698H8.89307V4.98441C8.89358 4.35823 9.06219 3.9296 9.93467 3.9296Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
  },
};
